module.exports = __webpack_public_path__ + "media/landing_page/instacart-grubhub-lockup-d58b52ce.svg";